import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate, useParams } from 'react-router-dom';

const EditProduct = () => {
    const { id } = useParams();
    const [customerName, setCustomerName] = useState('');
    const [staffId, setStaffId] = useState('');
    const [staffList, setStaffList] = useState([]);
    const [description, setDescription] = useState('');
    const [giverName, setGiverName] = useState('');
    const [productImage, setProductImage] = useState('');
    const [imagePreview, setImagePreview] = useState(null);
    const navigate = useNavigate();

    // Fetch staff list
    useEffect(() => {
        fetch('https://pbhrm.com/api/staff')
            .then(res => res.json())
            .then(data => {
                if (data.status === 1) {
                    setStaffList(data.data);
                }
            })
            .catch(err => console.error('Error fetching staff:', err));
    }, []);

    // Fetch existing product data
    useEffect(() => {
        fetch(`${BASE_URL}in-word-products/${id}`)
            .then(res => res.json())
            .then(data => {
                if (data.status === 1) {
                    const p = data.data;
                    setCustomerName(p.customer_name);
                    setStaffId(p.staff_id);
                    setDescription(p.description);
                    setGiverName(p.giver_name);
                    setProductImage(p.product_image);
                    setImagePreview(p.product_image.startsWith('http') ? p.product_image : `${BASE_URL}${p.product_image}`);
                } else {
                    alert('Product not found.');
                }
            })
            .catch(err => console.error('Error fetching product:', err));
    }, [id]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('customer_name', customerName);
        formData.append('staff_id', staffId);
        formData.append('description', description);
        formData.append('giver_name', giverName);

        if (productImage instanceof File) {
            formData.append('product_image', productImage);
        }

        fetch(`${BASE_URL}in-word-products/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Product updated successfully!');
                    navigate('/InWordProductsList');
                } else {
                    alert('Error updating product. Please try again.');
                }
            })
            .catch(err => console.error('Error updating product:', err));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProductImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Product</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Product Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="customer_name" className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            id="customer_name"
                                            className="form-control"
                                            value={customerName}
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="staff_id" className="form-label">Staff</label>
                                        <select
                                            id="staff_id"
                                            className="form-control"
                                            value={staffId}
                                            onChange={(e) => setStaffId(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Staff</option>
                                            {staffList.map(staff => (
                                                <option key={staff.id} value={staff.id}>
                                                    {staff.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="giver_name" className="form-label">Giver Name</label>
                                        <input
                                            type="text"
                                            id="giver_name"
                                            className="form-control"
                                            value={giverName}
                                            onChange={(e) => setGiverName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="product_image" className="form-label">Product Image</label>
                                        <input
                                            type="file"
                                            id="product_image"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                        {imagePreview && (
                                            <div className="mt-2">
                                                <img src={imagePreview} alt="Product" width="100" />
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Product</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditProduct;
